export default class PaymentProvider {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly logo: string;
  readonly isRecommended: boolean;
  readonly slug: "stripe" | "razorpay" | "billdesk";

  constructor(data: { [key: string]: any }) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.logo = data.logo;
    this.isRecommended = data.is_recommended;
    this.slug = data.slug;
  }
}
